import React, { useEffect, useState } from 'react'
import AuthenticatedPage from 'containers/AuthenticatedPage'
import { Dialog } from 'components/Popup'
import { getMessage } from 'lib/translator'
import RuleExclusionByOfferType from './RuleExclusionByOfferType'
import VerticalTabs from 'components/VerticalTabs'
import API from 'lib/api'
import Loader from 'components/Loader'
import './style.scss'

function OfferExclusions({ menu, history }) {
  const [exclusionRules, setExclusionRules] = useState(null)
  const [activeExclusionRuleIndex, setActiveExclusionRuleIndex] = useState(0)
  const [errorDialog, setErrorDialog] = useState(null)
  const [successDialog, setSuccessDialog] = useState(null)

  useEffect(() => {
    const exclusionRuleApi = new API({ url: `/offer-service/configurations/rule` })
    exclusionRuleApi
      .get()
      .then((response) => {
        setExclusionRules(response?.data?.global)
      })
      .catch((error) => {
        console.log(error)
      })
    return () => exclusionRuleApi && exclusionRuleApi.cancel()
  }, [])

  const handleTabChange = (selectedOfferTypeIndex) => {
    setActiveExclusionRuleIndex(selectedOfferTypeIndex)
  }

  const handleAddCategory = (offerType, value) => {
    const selectedRuleIndex = exclusionRules.findIndex(
      (rule) => rule.kind === offerType.kind
    )

    if (selectedRuleIndex > -1) {
      const newCategory = { id: value?.id, name: value?.name }

      // Update exclusionRules immutably
      setExclusionRules((prevRules) =>
        prevRules.map((rule, idx) => {
          if (idx !== selectedRuleIndex) {
            return rule
          }
          const nextCategories = Array.isArray(rule.categories)
            ? [...rule.categories, newCategory]
            : [newCategory]
          return { ...rule, categories: nextCategories }
        })
      )
    }
  }

  const handleRemoveCategory = (offerType, index) => {
    const selectedRuleIndex = exclusionRules.findIndex(
      (rule) => rule.kind === offerType.kind
    )

    if (selectedRuleIndex > -1) {
      // Update exclusionRules immutably by removing the category at the given index
      setExclusionRules((prevRules) =>
        prevRules.map((rule, idx) => {
          if (idx !== selectedRuleIndex) {
            return rule
          }
          const nextCategories =
            rule.categories?.filter((_, catIndex) => catIndex !== index) || []
          return { ...rule, categories: nextCategories }
        })
      )
    }
  }

  const handleSubmit = () => {
    const exclusionApi = new API({ url: '/offer-service/configurations/rule' })
    exclusionApi
      .post({ global: exclusionRules })
      .then((res) => {
        if (res?.data) {
          setSuccessDialog({
            title: 'Success',
            message: 'The changes are saved successfully.',
          })
        } else {
          setErrorDialog({
            title: 'Server Error',
            message: 'Unable to save changes.',
          })
        }
      })
      .catch((err) => {
        console.log(err)
        setErrorDialog({
          title: 'Server Error',
          message: 'Unable to save changes.',
        })
      })
  }

  return (
    <AuthenticatedPage className="offer-exclusions-rule-page" menu={menu}>
      <div className="header-container">
        <h2>{getMessage('offer.exclusions.header')}</h2>
      </div>

      {exclusionRules ? (
        <>
          <div className="vertical-tabs-container">
            <VerticalTabs
              data={exclusionRules}
              valueKey="kind"
              title="Offer Types"
              activeTab={exclusionRules[activeExclusionRuleIndex]}
              onTabChange={handleTabChange}
            />

            <div className="content-panel">
              <RuleExclusionByOfferType
                offerType={exclusionRules[activeExclusionRuleIndex]}
                handleAddCategory={handleAddCategory}
                handleRemoveCategory={handleRemoveCategory}
              />
            </div>
          </div>
          <div className="buttons-container">
            <button className={`button primary`} onClick={handleSubmit}>
              Submit
            </button>
            <button
              className="button secondary"
              onClick={() => history.push('/marketing/offers')}
            >
              Cancel
            </button>
          </div>
        </>
      ) : (
        <Loader />
      )}
      {errorDialog && (
        <Dialog
          show={!!errorDialog}
          title={errorDialog.title}
          information={errorDialog.message}
          close={() => setErrorDialog(null)}
          closeText={getMessage('dialog.okText')}
        />
      )}

      {successDialog && (
        <Dialog
          className="success"
          show={!!successDialog}
          title={successDialog.title}
          information={successDialog.message}
          close={() => setSuccessDialog(null)}
          closeText={getMessage('dialog.okText')}
        />
      )}
    </AuthenticatedPage>
  )
}

export default OfferExclusions
